import React from 'react';
import { Redirect } from 'react-router-dom';
import ui from 'redux-ui';
import ReactTable from "react-table";

import { Message } from '../Message';
import { PageTitle } from '../PageTitle';
import { CompletedChecklistService, TimeFormattingService } from '../../services';
import i18next from "i18next";

class CompletedChecklists extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      localErrorMessage: null
    };
  }
  messageDismissCallback() {
    this.setState({ localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage) {
      return (
        <Message errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }
    return null;
  }

  handleLocalError(localErrorMessage) {
    this.setState({ localErrorMessage: localErrorMessage });
  }

  render() {
    return (
      <div className="animated fadeIn">
        <div className="row">
          <PageTitle title={ i18next.t('pages.completed-checklists.header') }/>
        </div>
        {this.renderMessages()}

        <div className="op-content-box">
          <div className="row">
            <div className="col-sm-12">
              <div>
                <div className="card-block">

                  <ChecklistList localErrorHandler={this.handleLocalError.bind(this)} />

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const RowButton = (props) => {
  return (
        <div>
             <button className="btn btn-sm btn-default"
                     onClick={() => props.viewClick(props.rowId)}
                     >{ i18next.t('form-labels.view') }</button>
         </div>
  );
}
@ui({
  key: 'checklist-list',
  persist: true,
  state: {
    prevPage: null
  }
})

class ChecklistList extends React.Component {

  // TODO correctly handle timezones here

  constructor(props) {
    super(props);
    this.fetchData = this.fetchData.bind(this);
    this.datafetched = this.datafetched.bind(this);
    this.makeDatatableRequest = this.makeDatatableRequest.bind(this);

    this.state = {
      linkTo: null,
      localErrorHandler: this.props.localErrorHandler,
      hasError: false,
      data: [],
      pages: null,
      loading: true,
      totalElements: null,
    };
  }

  viewLinkClick(rowId) {
    this.setState({ linkTo: `/monitoring/checklists/${rowId}` });
  }

  makeDatatableRequest (data, callback, settings) {
    if (this.state.hasError) {
      return;
    }

    let options = [
      { 'size': data.pageSize },
      { 'page': data.page }
    ];

    let neworder = data.sorted ? data.sorted :
                                  this.refs.checklistTable ? this.refs.checklistTable.state.sorted :
                                                           null;
    if (neworder && neworder.length > 0) {
      neworder.forEach(order => {
        options.push({ 'sort': `${order.id},${order.desc ? "desc":"asc"}` });
      })
    }

    let isSearch = false;
    if (data.search && data.search.value != null && data.search.value !== '') {
      options.push({ 'search': data.search.value });
      isSearch = true;
    }

    CompletedChecklistService.getAll(options, true).then(response => {
      callback({
        data: response.checklists,
        recordsTotal: response.page.totalElements,
        recordsFiltered: response.page.totalElements
      });
    }).catch(error => {
      console.error(error);
      this.setState({ hasError: true });
      callback({ data: [], recordsTotal: 0, recordsFiltered: 0 });
      this.state.localErrorHandler(error.message);
    });
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    if (this.table) {
      this.table.ajax.reload();
    }
  }

  datafetched(res) {
    let size = this.refs.checklistTable.state.pageSize;
    let page = this.refs.checklistTable.state.page;
    this.setState({
      data: res.data,
      pages: Math.ceil(res.recordsTotal / size),
      page: page,
      pageSize: size,
      loading: false,
      totalElements: res.recordsTotal
    });
  }

  fetchData(state, instance) {
    this.setState({
      loading: true
    });
    this.makeDatatableRequest(state, this.datafetched, null);
  }

  renderNormalTime(data) {
    if (data.value) {
      let timezone = data.original.deviceGrouping && data.original.deviceGrouping.timezone ? data.original.deviceGrouping.timezone : null;
      let date = TimeFormattingService.renderDate(data.value, timezone);
      let time = TimeFormattingService.renderTime(data.value, timezone);
      return <span>{date}<br/>{time}</span>;
    } else {
      return <span></span>;
    }
  }

  render() {
    const { data, pages, loading, totalElements } = this.state;

    if (this.state.linkTo) {
      return <Redirect push to={this.state.linkTo} />;
    }

    return (
      <div className="react-table-custom">
      <ReactTable
        className="-striped -highlight"
        ref="checklistTable"
        manual // Forces table not to paginate or sort automatically, so we can handle it server-side
        data={data}
        pages={pages} // Display the total number of pages
        loading={loading} // Display the loading overlay when we need it
        onFetchData={this.fetchData} // Request new data when things change
        totalElements={totalElements}
        showPaginationTop
        columns={[
                    {
                      Header: "Name",
                      accessor: "checklistConfig.name",
                      sortable: true,
                      minResizeWidth: 50
                    },
                    {
                      Header: "Started At",
                      accessor: "startTime",
                      Cell: cell => this.renderNormalTime(cell),
                      sortable: true,
                      minResizeWidth: 50
                    },
                    {
                      Header: "Ended At",
                      accessor: "endTime",
                      Cell: cell => this.renderNormalTime(cell),
                      sortable: true,
                      minResizeWidth: 50
                    },
                    {
                      Header: "Completed Item Count",
                      accessor: "completedChecklistItems",
                      sortable: false,
                      minResizeWidth: 50
                    },
                    {
                      Cell: cell => <RowButton viewClick={this.viewLinkClick.bind(this)} rowId={cell.original.id} />,
                      sortable: false,
                      minResizeWidth: 50
                    }
                  ]}
      />
      </div>
    );
  }
}

export default CompletedChecklists;
